import React from "react";
import { Box, Typography, Grid2 } from "@mui/material";
import { Theme } from "../Theme";
import { ThemeProvider } from "@mui/material/styles";

export default function ContactUs() {
  return (
    <ThemeProvider theme={Theme}>
      <Box
        sx={{
          minHeight: { xs: "100vh", md: "100vh" }, // Ensure full viewport height
          background: "linear-gradient(135deg, #001d32 30%, #004080 100%)", // Gradient background
          color: "white",
          padding: "0px 20px", // Add consistent padding
          display: "flex",
          flexDirection: "column",
          alignItems: "center", // Center all items horizontally
          // /justifyContent: "center", // Center all items vertically
        }}
      >
        <Grid2
          sx={{
            maxWidth: "900px", // Limit content width for better readability
            width: "100%",
            textAlign: "center",
            marginBottom: "40px",
          }}
        >
          {/* <Typography variant="h3" gutterBottom sx={{ fontWeight: "bold" }}>
          Contact Us
        </Typography>
        <Typography variant="subtitle1" sx={{ opacity: 0.8 }}>
          Feel free to reach out to us with any questions or inquiries.
        </Typography> */}
        </Grid2>

        {/* Section: Contact Information */}
        <Grid2
          sx={{
            maxWidth: "750px",
            width: "100%",
            backgroundColor: "#1a3953",
            borderRadius: "10px",
            padding: "20px 30px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            marginBottom: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center", // Horizontally center the content
            justifyContent: "center", // Vertically center the content
          }}
        >
          <Typography variant="h2">Contact Information</Typography>
          <Typography
            variant="body1"
            sx={{ opacity: 0.9, textAlign: "center" }}
          >
            Email: support@intelinext.co.uk
          </Typography>
        </Grid2>

        <Grid2
          sx={{
            maxWidth: "800px",
            width: "100%",
            height: "450px",
            borderRadius: "10px",
            overflow: "hidden",
            marginTop: "20px",
          }}
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2364.2092680358355!2d-2.9855012999999992!3d53.6610702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487b3f034d48679d%3A0x4c2e63cff3b5304b!2s37%20Hesketh%20Rd%2C%20Southport%20PR9%209PB!5e0!3m2!1sen!2suk!4v1736176827515!5m2!1sen!2suk"
            width="100%"
            height="100%"
            style={{
              border: 0,
            }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </Grid2>
      </Box>
    </ThemeProvider>
  );
}
